import { wireGoogleAds } from './wireGoogleAds'
import { wireClassicEvents } from './wireClassicEvents'
import { wireCriteoEvents } from './wireCriteoEvents'

export default ({ app, $sitewideData, $integrationsManager }) => {
    // init to get the party started
    window.dataLayer = window.dataLayer || []

    // keep datalayer aware of current email
    const email = app.$emailTracker.getEmail()
    if (email) window.dataLayer.push({ email })

    app.$uiEvents.$on('emailSet', () =>
        window.dataLayer.push({ email: app.$emailTracker.getEmail() })
    )

    wireGoogleAds(app)
    wireClassicEvents(app)
    wireCriteoEvents(app)

    $integrationsManager.loaders.onLoadLoader(() => {
        const containerIds = []
        containerIds.push($sitewideData.config.googleTagManagerContainerId)
        containerIds.forEach((containerId) => {
            /* eslint-disable */
            // prettier-ignore
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',containerId)
        })
    })
}
